import { createStack } from 'hub-http';
import hubapiStack from 'hub-http/stacks/hubapi';
import promiseClient from 'hub-http/adapters/promiseClient';
import { safeMode } from 'hub-http/middlewares/core';
// @ts-expect-error cookieAuth doesn't have declared types
import { allowMissingPortalId } from 'hub-http/middlewares/cookieAuth';
import { queryLocalStorage } from './localstorage';
import { getFullUrl } from 'hubspot-url-utils';
import { createRpcClientV2 } from 'rpc-client-utils';
export const DEFAULT_RETRY_DELAY_MS = 1000;
export const apiClientWithMiddleware = () => {
  const middlewareStack = [safeMode, allowMissingPortalId, hubapiStack];
  return promiseClient(createStack(...middlewareStack));
};
export const rpcClient = createRpcClientV2({
  hubHttpClient: apiClientWithMiddleware()
});
export const maybeUseLocalUrl = ({
  localOverrideKey
}) => {
  const shouldUseLocalOverride = queryLocalStorage(localOverrideKey) === 'local';
  if (shouldUseLocalOverride) {
    return getFullUrl('local');
  }
  return getFullUrl('app');
};